import cloneDeep from "lodash-es/cloneDeep";
import Big from "big.js";
import axios from "../../../axios";
import { formStateStore } from "../../../Redux/Store/store";
import { updateAdvFormData, updateGridContexts } from "../../../Redux/Actions/FormStateActions";
import { recursiveJsonReader1, functions } from "../../../components/IFormDesignerLayout/ApplicationAPI/applicationApi";
import {
  getGdToken,
  getWIToken,
  getGlobalContext,
  changeControlProperty,
  updatePartialJSON,
  getOpenCanvasForPreviewAdvance,
  getGridStates
} from "../../../components/IFormDesignerLayout/IFormDesignerLogic";
import { handleFocus, getHooksId } from "../../../Resources/globalFunctions";
import { GRID_CELL_BLOCK_PADDING } from "./gridConstants";
import secureLocalStorage from "react-secure-storage";
import { GetExactDevice } from "../../../components/CustomHooks/CustomHooks";
import { updateFormStateStructureByElemType } from "../../../components/IFormDesignerLayout/SectionLayoutLogic";
const secureNgsmtoken = secureLocalStorage.getItem("ngsmtoken");
const ngsmtoken = secureNgsmtoken;

const totalAllowedForMasking = [
  "currency_bahamas",
  "currency_dollar",
  "currency_euro",
  "currency_naira",
  "currency_rupees",
  "currency_yen",
  "currency_french",
  "percentage",
  "dgroup2",
  "dgroup3"
];

const columnTypeList = [
  "datepick",
  "datetimepick",
  "button",
  "radio",
  "label",
  "link",
  "checkbox",
  "toggle"
];

const maskingList = ["B$ ", "$ ", "€ ", "₦ ", "₹", "¥ ", " CHF", "%", "(", "-"];
const prefixMaskingArray = [
  ["currency_bahamas", "B$ "],
  ["currency_dollar", "$ "],
  ["currency_euro", "€ "],
  ["currency_naira", "₦ "],
  ["currency_rupees", "₹ "],
  ["currency_yen", "¥ "]
];
const sufixMaskingArray = [
  ["currency_french", " CHF"],
  ["percentage", "%"]
];

const maskingArray = {
  "currency_bahamas": "B$ ",
  "currency_dollar": "$ ",
  "currency_euro": "€ ",
  "currency_naira": "₦ ",
  "currency_rupees": "₹ ",
  "currency_yen": "¥ ",
  "currency_french": " CHF",
}
const prefixMaskingMap = new Map(prefixMaskingArray);
const sufixMaskingMap = new Map(sufixMaskingArray);

export const updateSubFormJSON = (json) => {
  const contexts = getGlobalContext();

  const { device } = contexts
  const {isDesktop, isTablet,isMobile} = GetExactDevice();
  var columnLayout, view, prevView;
  if (device === "mobile" || isMobile) {
    columnLayout = 1;
    view = "mobile";
    prevView = "none";
  }
  if (device === "tablet" || isTablet) {
    columnLayout = 2;
    view = "tablet";
    prevView = "none";
  }
  if (device === "web" || isDesktop) {
    columnLayout = 3;
    view = "web";
    prevView = "none";
  }

  var newJson_dummy = {};
  newJson_dummy.children = [json];

  let updatedFormState1 = updateFormStateStructureByElemType(
    newJson_dummy,
    columnLayout,
    view,
    prevView,
  );

  var updatedFormState_var = updatedFormState1.children[0];

  if (updatedFormState_var?.currentDeviceOnApp) {
    updatedFormState_var.currentDeviceOnApp = view;
  }
  return updatedFormState_var;
};

export const callSelectRowHook = (tableData = {}, keys = [], isCheckedAll = false, calledFromCustomAPI, currSelectedRow) => {
  const shouldTriggerHook = calledFromCustomAPI ? tableData.style.callPostHook : true;
  if (window.selectRowHook && shouldTriggerHook) {
    let allKeysChecked = false;

    if (tableData.rowData.length === keys.length) {
      allKeysChecked = true;
    }
    window.selectRowHook(getHooksId(tableData), keys, isCheckedAll || allKeysChecked, currSelectedRow, calledFromCustomAPI);
    functions.updateJSON();
  }
}

export const handleCheckAll = (value, checked, data, setCheckedKeys, setCheckedAll, checkedAll, tableData) => {
  let keys = checked ? data.map((item) => item.id) : [];
  if (data[data.length - 1]?.isShowTotal) {
    keys.pop();
  }

    if(tableData?.rowData?.length) {
    console.log("RowData -2", tableData.rowData)
    tableData.rowData.forEach((row, index) => {
      console.log("RowData -3", {row, index})
      if(row?.Disabled) {
        keys = keys.filter(item=> item !== index);
      }
    })
  }

  setCheckedKeys(keys);
  setCheckedAll(!checkedAll);
  callSelectRowHook(tableData, keys, true)
};

export const getDataKey = (tableData={}, columnStyle={}, rowData={}) => {
  const dataKey =
    tableData?.elem_type?.toLowerCase() === "table"
      ? columnStyle?.ColumnName
      : columnStyle.ColumnType === "button"
      ? columnStyle?.ColumnName
      : tableData?.elem_type === "listview"
      ? rowData?.hasOwnProperty(columnStyle?.ColumnName) && typeof rowData?.[columnStyle?.ColumnName] !== "object"
        ? columnStyle?.ColumnName
        : `${tableData?.dataclass ?? ""}.${columnStyle?.complexFieldName ?? ""}`
      : columnStyle?.complexFieldName;

      // console.log("getDataKey", {dataKey, tableData, columnStyle, rowData});

      return dataKey
};

export const getGridColumnJSON = (tableData, columnName) => {
  const tableColumnList = tableData?.columnList || [];
  const column = tableColumnList.find((item) => {
      const dataKey = getDataKey(tableData, item.style);
      return item.style.ColumnName === columnName || item.style.complexFieldName === columnName || dataKey === columnName
    }
  );

  return column || {};
};

export const parseColumnIndex = (tableData = {}) => {
  if (tableData.columnList?.length) {
      const isParseRequired = tableData.columnList.some(column => typeof column.columnIndex === "string");

      if(isParseRequired) {
          tableData.columnList.forEach((column) => {
              column.columnIndex = parseInt(column.columnIndex);
          });
          updatePartialJSON(tableData.id, tableData);
      }
  }
};

export function setLableText(selector, parentRefs) {
  const allCheckboxes = document.querySelectorAll(selector);

  if (allCheckboxes?.length) {
    allCheckboxes.forEach((element) => {
      if (element && !parentRefs.current.includes(element)) {
        parentRefs.current.push(element);
      }
    });

    parentRefs.current.forEach((ref) => {
      const pElems = ref.querySelector("p");

      if (ref && !pElems) {
        const newElement = document.createElement("p");
        newElement.innerText = "sometext";
        newElement.style.display = "none";
        ref.appendChild(newElement);
      }
    });
  }
}

export function setDatePickerLableText(selector) {
  const datePickerDiv = document.querySelectorAll(selector);

  if (datePickerDiv?.length) {
    datePickerDiv.forEach((element) => {
      const inputD = element.querySelector("input");
      if (inputD) {
        inputD.setAttribute("aria-label", "Control Value2");
      }
    });
  }
}

function getJsonRowData (rowData = {}, tableData = {}, dataKey = "") {
  const curRow = tableData?.rowData?.[rowData?.id];
  let isCellDisabledFFN = null;
  if(curRow) {
    for (var i = 0; i < Object.keys(curRow).length; i++) {
      const curCell = curRow?.[i];
      if(curCell?.name === dataKey) {
        isCellDisabledFFN = curCell?.style?.Disabled === undefined ? null : curCell?.style?.Disabled;
      }
    }
  }
  return (dataKey === "id" ? rowData["disabled_prop"] : isCellDisabledFFN) && !rowData?.isShowTotal;
}

export function checkRowDisabled(rowData, key, isColumnDisable, tableData) {
  const isColumnDisableFFN = isColumnDisable && !rowData?.isShowTotal;
  const isCellDisabledFFN = getJsonRowData(rowData, tableData, key);
  
  const isRowDisbaleNotSet = isCellDisabledFFN === undefined || isCellDisabledFFN === null;
  const isCellDisabled = isRowDisbaleNotSet ? isColumnDisableFFN : isCellDisabledFFN;

  return isCellDisabled; // from function
}

export const getCellBackgroundColor = (
  rowStyling,
  rowData,
  dataKey,
  isStripped,
  isCellDisabled,
  isRowSelected,
  gridTileView
) => {
  const selectedRowBackgroundColor = isRowSelected ? rowStyling?.selectedRowColor : undefined;
  const styleBackgroundColor = rowStyling?.backgroundColor;
  const disabledCellBackgroundColor = isCellDisabled ? "#f0f0f0" : undefined;
  const customAPIBackgroundColor =
    rowData?.isShowTotal || gridTileView ? undefined : rowData?.["cellBackGround"]?.get(dataKey);

  const cellBackgroundColor = isStripped
    ? gridTileView
      ? "#fff"
      : rowData?.id % 2 === 0
      ? "transparent"
      : styleBackgroundColor
    : styleBackgroundColor || "transparent";

  return customAPIBackgroundColor || disabledCellBackgroundColor || selectedRowBackgroundColor || cellBackgroundColor;
};

export function getWidthValue(columnWidth, type) {
  const newFlexValue = columnWidth.replace("%", "");
  const intValue = parseInt(newFlexValue);

  if (type === "int") {
    return intValue;
  }

  const floatVal = intValue / 10;
  return floatVal;
}

export function checkMaskingType(tableData, key) {
  let result = ["", "", "", ""];
  const keyParts = key?.split('.') || [];
  const simpleKey = keyParts[keyParts.length - 1] || '';

  for (let item of tableData.columnList) {
    const dataKey = getDataKey(tableData, item.style);

    if (item.style.complexFieldName === key || item.style.ColumnName === key || key === dataKey || simpleKey === item.style.complexFieldName) {
      let columnMasking = item.style?.ColumnMasking || "";

      // For listview/advance listview, fall back to the popup control's MaskingValue when ColumnMasking is not set
      if (!columnMasking && tableData?.listviewFrameLayoutJson) {
        const isAdvanceListview = tableData?.elem_type?.toLowerCase() === "advancelistview";
        const isListview = tableData?.elem_type === "listview";
        if (isAdvanceListview || isListview) {
          const controlId = isAdvanceListview
            ? item.style.complexFieldName
            : `${tableData.id}_${item.style.ColumnName}`;
          const controlJson = recursiveJsonReader1(
            tableData.listviewFrameLayoutJson,
            controlId,
            "control"
          );
          const maskingValue = controlJson?.style?.MaskingValue;
          if (maskingValue && maskingValue !== "Select" && maskingValue !== "nomasking" && maskingValue !== "") {
            columnMasking = maskingValue;
          }
        }
      }

      result = [
        columnMasking,
        item?.style?.CustomMasking || "",
        item?.style?.complexFieldType || "",
        item?.style?.complexFieldVariablePrecision || ""
      ];
    } else {
      continue;
    }
  }
  return result;
}

export function maskingExists(value) {
  for (let item of maskingList) {
    if (typeof value !== "boolean" && value.includes(item)) {
      return true;
    }
  }
  return false;
}

export function formatPhoneNumber(phoneNumber) {
  if (phoneNumber?.includes("(")) return phoneNumber;

  const areaCode = phoneNumber.slice(0, 2);
  const remainingDigits = phoneNumber.slice(2);
  const result = `(${areaCode}) ${remainingDigits}`;

  return result;
}

function formatDecimal(value, decimalCount){
  try {
    const num = value.replace(/\s*%/, "");
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
    let numberOnly = value;

    if(isNaN(Number(value))) {
      numberOnly = Number(value.replace(/[^0-9.-]/g, ""));
    }

    const negativeSign = numberOnly < 0 ? "-" : "";

    const formattedValue = Math.abs(numberOnly || 0).toFixed(decimalCount).toString()

    return (negativeSign + formattedValue + " %")
  } catch(e) {
    console.log(e)
  }
}

export function formatUS(amount, decimalCount = 0, decimal = ".", thousands = ",") {
  try {
    let formattedAmount = amount.replace(/[^0-9.]/g, "");
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = formattedAmount < 0 ? "-" : "";

    let i = parseInt((formattedAmount = Math.abs(Number(formattedAmount) || 0).toFixed(decimalCount))).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(formattedAmount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    console.log(e);
  }
}

export function formatIndia(value, precision) {
  if((!value && value !== 0) || value === "") return "";
  if (value?.includes(",")) return value;

  let valueWithoutDecimal, decimalValue;

  value= String(value);

  if(value.includes(".")){
    [valueWithoutDecimal, decimalValue] = value.split(".")
    decimalValue = "." + decimalValue;
  } else if (precision > 0) {
    valueWithoutDecimal = value;
    decimalValue = "." + "0".repeat(precision);
  } else {
    valueWithoutDecimal = value;
    decimalValue="";
  }

  let lastThree = valueWithoutDecimal.substring(valueWithoutDecimal.length - 3);
  const otherNumbers = valueWithoutDecimal.substring(0, valueWithoutDecimal.length - 3);

  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }

  const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + decimalValue;
  return res;
}

export function formatUSCustomMasking(amount, decimalCount = 0, decimal = ".", thousands = ",") {
  try {
    let formattedAmount = amount.replaceAll(",", "");
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = formattedAmount < 0 ? "-" : "";

    let i = parseInt((formattedAmount = Math.abs(Number(formattedAmount) || 0).toFixed(decimalCount))).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(formattedAmount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    console.log(e);
  }
}

export function formatNumberToLakhSeparator(value, lakhSeparator = ",") {
  const stringValue = String(value);

  if (!stringValue.includes(".")) {
    let lastThree = stringValue.substring(stringValue.length - 3);
    let otherNumbers = stringValue.substring(0, stringValue.length - 3);
    if (otherNumbers !== "") lastThree = lakhSeparator + lastThree;
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, lakhSeparator) + lastThree;
  }

  // If the value contains a decimal point, return as is
  return stringValue;
}

export function formatValue(maskingType, value, CustomMasking, complexFieldType, complexFieldVariablePrecision) {
  let prefix = "";
  let suffix = "";

  if (value === "" || value === null || value === undefined) {
    return value
  }

  if (maskingType) {
    prefix = prefixMaskingMap.get(maskingType);
    suffix = sufixMaskingMap.get(maskingType);
    
     const getActualDecimalPlaces = (val) => {
      if (val == null) return 0;
      const str = String(val);
      const dotIndex = str.indexOf(".");
      return dotIndex !== -1 ? str.length - dotIndex - 1 : 0;
    };

    if (maskingType === "dgroup2") {
      value = formatIndia(value, complexFieldType === "Float" ? complexFieldVariablePrecision || 2 : getActualDecimalPlaces(value));
    } 
    else if (maskingType === "dgroup3" || maskingType === "currency_dollar") {
      value = formatUS(value, complexFieldType === "Float" ? complexFieldVariablePrecision || 2 : getActualDecimalPlaces(value));
    } else if (maskingType === "(00) 0000000000") {
      value = formatPhoneNumber(value);
    } else if (maskingType === "000-000") {
      value = value.replace(/(\d{3})(\d{3})/, "$1-$2");
    } else if (maskingType === "percentage") {
      value = formatDecimal(value, complexFieldType === "Float" ? complexFieldVariablePrecision || 2 : getActualDecimalPlaces(value));
    } else if (!value?.includes(maskingType)) {
      if (CustomMasking?.psign === "p") {
        prefix = CustomMasking?.asign;
      } else if (CustomMasking?.psign === "s") {
        suffix = CustomMasking?.asign;
      }

      if (CustomMasking?.dgroup === "3") {
        const maskingValueArray = value?.split(CustomMasking?.asign).join("");
        value = formatUSCustomMasking(
          maskingValueArray,
          CustomMasking?.decimal || "2",
          CustomMasking?.adec || ".",
          CustomMasking?.asep || ","
        );
      } else if (CustomMasking?.dgroup === "2") {
        const maskingValueArray = value?.split(".");
        let formattedValue = formatNumberToLakhSeparator(maskingValueArray[0]);
        formattedValue = formattedValue.replaceAll(",", CustomMasking?.asep);

        value = formattedValue + CustomMasking?.adec + maskingValueArray[1];
      }
    }
  }

  if (value && maskingExists(value)) {
    return value;
  }

  const finalValue = (prefix ? `${prefix} ` : "") + value + (suffix ? ` ${suffix}` : "");
  return finalValue;
}

function isDropDown(tableData, valueObj) {
  const { name: columnName, value, extraOptions, queryOptions } = valueObj;
  const parts = columnName?.split('.') || [];
  const simpleColName = parts[parts.length - 1] || '';
  const isQueryOptions = queryOptions && Array.isArray(queryOptions) && queryOptions.length > 0;


  for (let column of tableData.columnList) {
    const dataKey = getDataKey(tableData, column.style);
    if (columnName === column.style.ColumnName || columnName === column.style.complexFieldName || dataKey === columnName || simpleColName === column.style.complexFieldName) {
      if ((column.style.ColumnType === "combo" || column.style.ColumnType === "radio") && tableData.elem_type !== "table") {
        let eleJson = recursiveJsonReader1(
          tableData.listviewFrameLayoutJson,
          tableData.elem_type === "listview"
            ? `${tableData.id}_${column.style.ColumnName}`
            : tableData?.elem_type?.toLowerCase() === "advancelistview"
            ? column.style.complexFieldName
            : columnName,
          "control"
        );
        let opt = cloneDeep((isQueryOptions ? queryOptions : eleJson?.options || eleJson?.style?.options || null))
        if (extraOptions) {
          opt?.push(...extraOptions);
        }
        if (opt) {
          for (let option of opt) {
            if (value === option.value && option.value !== "") {
              return option.label;
            }
          }
          // If value matches the label of a placeholder option (empty value), treat it as empty
          const isPlaceholderLabel = opt.some(option => option.value === "" && option.label === value);
          if (isPlaceholderLabel) {
            return "";
          }
        }
        return value || "";
      } else if (column.style.ColumnType === "toggle" && tableData.elem_type !== "table") {
        return value === true || value === "true"
          ? column.style.ToggleState2 || true
          : column.style.ToggleState1 || false;
      } else {
        return value;
      }
    }
  }
  return value;
}

export const removeOptionFromCombo = (options, indexesToRemove) => {
  // Convert indexes to a Set for faster lookup
  const indexesSet = new Set(indexesToRemove);
  const filteredArray = options.filter((_, index) => !indexesSet.has(index));
  console.log(filteredArray);
  return filteredArray;
}

export function formatTableData(tableData, formattedData) {
  let resultData = [];
  const rowData = tableData.rowData;
  const response1 = tableData?.rowData ? tableData : {};
  const response2 = response1 ? response1?.rowData : [];

  const rowDataLength = response2.length;
  const MaxLoopIteration = 999999;

  if (rowDataLength < MaxLoopIteration) {
    for (let row = 0; row < rowDataLength; row++) {
      let obj = { id: parseInt(row) };
      // obj["disabled_column_names"] = [];
      obj["TableButtonImageFile"] = new Map();
      obj["ButtonLabel"] = new Map();
      obj["TableButtonBGColor"] = new Map();
      obj["cellBackGround"] = new Map();
      obj["ShowCellData"] = new Map();
      // obj["row_disabled"] = false;
      obj["LabelColor"] = new Map();
      obj["BackgroundColor"] = new Map();
      obj["BorderRadius"] = new Map();
      obj["minDate"] = new Map();
      obj["maxDate"] = new Map();

      if (rowData[row]?.Disabled) {
        obj["disabled_prop"] = true;
      }
      if (rowData[row]?.Visible === false) {
        continue;
      }

      Object.entries(rowData[row]).forEach((entry, index) => {
        const valueObj = entry[1];
        const key = valueObj.name;
        let value = isDropDown(tableData, valueObj);

        if (value && key) {
          const [maskingType, CustomMasking, complexFieldType, complexFieldVariablePrecision] = checkMaskingType(
            tableData,
            key
          );
          if (maskingType || CustomMasking) {
            const finalValue = formatValue(
              maskingType,
              value,
              CustomMasking,
              complexFieldType,
              complexFieldVariablePrecision
            );
            obj[key] = finalValue;
          } else {
            obj[key] = value;
          }
        } else {
          obj[key] = value;
        }

        // if (valueObj?.style?.Disabled) {
        //   obj["disabled_column_names"].push(key);
        // }
        if (valueObj?.style?.BackColor) {
          obj["cellBackGround"].set(key, valueObj?.style?.BackColor);
        }
        if (valueObj?.style?.ShowCellData !== undefined) {
          obj["ShowCellData"].set(key, valueObj?.style?.ShowCellData);
        }
        if (valueObj?.style?.TableButtonImageFile) {
          obj["TableButtonImageFile"].set(key, valueObj?.style?.TableButtonImageFile);
        }
        if (valueObj?.style?.ButtonLabel) {
          obj["ButtonLabel"].set(key, valueObj?.style?.ButtonLabel);
        }
        if (valueObj?.style?.TableButtonBGColor) {
          obj["TableButtonBGColor"].set(key, valueObj?.style?.TableButtonBGColor);
        }
        if (valueObj?.style?.LabelColor) {
          obj["LabelColor"].set(key, valueObj?.style?.LabelColor);
        }
        if (valueObj?.style?.BackgroundColor) {
          obj["BackgroundColor"].set(key, valueObj?.style?.BackgroundColor);
        }
        if (valueObj?.style?.BorderRadius) {
          obj["BorderRadius"].set(key, valueObj?.style?.BorderRadius);
        }
        if (valueObj?.style?.minDate) {
          obj["minDate"].set(key, valueObj?.style?.minDate);
        }
        if (valueObj?.style?.maxDate) {
          obj["maxDate"].set(key, valueObj?.style?.maxDate);
        }
        if (valueObj?.clearCombo) {
          obj[`${key}_clearOptions`] = valueObj.clearCombo;
        }
        if (valueObj?.clearComboNew) {
          obj[`${key}_clearOptionsNew`] = valueObj.clearComboNew;
        }
        if (valueObj?.extraOptions) {
          obj[`${key}_extraOptions`] = valueObj.extraOptions;
          obj[`${key}_newOptions`] = valueObj.extraOptions;
        }
        if (valueObj?.queryOptions && Array.isArray(valueObj.queryOptions) && valueObj.queryOptions.length > 0) {
          obj[`${key}_queryOptions`] = valueObj.queryOptions;
        }
        if (valueObj?.removeOptionIndex || valueObj?.removeOptionIndex === 0 || valueObj?.removeOptionIndex?.length) {
          obj[`${key}_removeOptionIndex`] = valueObj.removeOptionIndex;
        }
      });

      resultData.push(obj);

      if (
        row === rowData?.length - 1 &&
        (tableData?.columnList?.some((item) => item?.style?.ShowTotalListview === "true") ||
          tableData?.style?.ShowTotal === "true")
      ) {
        const showTotalRow = formattedData.filter((item) => item.isShowTotal);
        const filteredResultData = resultData.filter((item) => !item.isShowTotal);
        const showTotalEnabledColumn = { isShowTotal: true };

        if (showTotalRow?.length) {
          filteredResultData.push(showTotalRow[0]);
        } else {
          tableData?.columnList?.forEach((item) => {
            if (item?.style?.ShowTotalListview === "true") {
              const dataKey = getDataKey(tableData, item.style, filteredResultData);
              showTotalEnabledColumn[dataKey] = "";
            }
          });

          filteredResultData.push(showTotalEnabledColumn);
        }

        resultData = [...filteredResultData];
      }
    }
  }
  return resultData;
}

export function findTextarea(tableData, rowHeight) {
  let textareaMaxHeight = 75; // textarea should minimum have 3 rowHeight for better UI (1 rowHeight = 25px)
  let isTextarea = false;

  for (let column of tableData.columnList) {
    if (column.style.ColumnType === "textarea" && !column.style.controlName) {
      const columnHeight = parseInt(column?.style?.TableTextAreaHeight || 0);
      isTextarea = true;

      if (columnHeight > textareaMaxHeight) {
        textareaMaxHeight = columnHeight;
      }

      if (rowHeight > textareaMaxHeight) {
        textareaMaxHeight = rowHeight;
      }

      textareaMaxHeight = textareaMaxHeight + GRID_CELL_BLOCK_PADDING;
    }
  }

  return { textareaMaxHeight, isTextarea };
}

export const getTotal = (key, tableData, dataToSum = []) => {
  let sum = "0";
  let result = '';
  const [maskingType, CustomMasking] = checkMaskingType(tableData, key);
  const isTotalAllowed = totalAllowedForMasking.includes(maskingType);

  if (!isTotalAllowed && (maskingType || CustomMasking) && maskingType !== "nomasking") {
    return "";
  }

  let curColumn = [];
  const rowData = dataToSum[0];
  if (tableData?.elem_type?.toLowerCase() === "advancelistview") {
    curColumn = tableData.columnList.filter((item) => key === item.style?.complexFieldName);
  } else if (tableData?.elem_type?.toLowerCase() === "listview" && dataToSum.length) {
    curColumn = tableData.columnList.filter((item) => {
      const dataKey = getDataKey(tableData, item.style, rowData);
      
      return key === dataKey;
    });
  } else {
    curColumn = tableData.columnList.filter((item) => key === item?.style?.ColumnName);
  }

  if (!curColumn?.length) {
    return "";
  }

  const isTotalAllowedColumnType = columnTypeList.includes(curColumn[0].style.ColumnType);

  if(isTotalAllowedColumnType) {
    return "";
  }

  const isShowTotalGridCheck = tableData?.style?.ShowTotal;
  if (isShowTotalGridCheck === "false" || !isShowTotalGridCheck) {
    const isShowTotalColumnCheck = curColumn[0]?.style?.ShowTotalListview;
    if (isShowTotalColumnCheck === "false" || !isShowTotalColumnCheck) {
      return "";
    }
  }

  for (let i = 0; i < dataToSum?.length - 1; i++) {
    const currentNumber = dataToSum?.[i]?.[key] || "";
    if (typeof currentNumber === "string") {
      let isNanCheck = false;
      const numProp = (maskingType || CustomMasking) ? currentNumber.replace(/[^-0-9.]/g, "") : currentNumber; // remove all char except number, minus, dot

      if (!isTotalAllowed) {
        isNanCheck = isNaN(numProp);
      }

      const num = new Big(numProp === "" || isNanCheck ? "0" : numProp);

      let summedValue = num.plus(sum);
        formatValue(maskingType, sum, CustomMasking,"","",)
      if (curColumn[0]?.style["complexFieldVariablePrecision"]) {
        sum = summedValue.toFixed(parseInt(curColumn[0]?.style["complexFieldVariablePrecision"]));
      } else if (curColumn[0]?.style["complexFieldVariablePrecision"] === "") {
        sum = summedValue.toFixed(2);
      } else {
        sum = summedValue.toFixed(0);
      }
    }
    result = formatValue(maskingType, sum, CustomMasking,curColumn[0]?.style["complexFieldType"], curColumn[0]?.style["complexFieldVariablePrecision"]);

  }

  // const formattedValue = formatValue(maskingType, sum, CustomMasking,"","",);

  return result;
};

export const handleShowTotal = (tableData, dataToSum, isChange, key) => {
  const nextData = [...(dataToSum || [])];

  if (
    nextData.length &&
    nextData[nextData.length - 1]?.isShowTotal &&
    (tableData?.columnList?.some((item) => item?.style?.ShowTotalListview === "true") ||
      tableData?.style?.ShowTotal === "true")
  ) {
    if (isChange) {
      nextData[nextData.length - 1][key] = getTotal(key, tableData, nextData) || "";
    } else {
      Object.keys(dataToSum[0]).forEach((item) => {
        nextData[nextData.length - 1][item] = getTotal(item, tableData, nextData) || "";
      });
    }
  }
  return nextData;
};

export const setControlsDisabled = (tableData) => {
  if (tableData?.style?.Enable === false || tableData?.style?.Enable === "false") {
    changeControlProperty(tableData.style.Enable, "Enable", tableData?.listviewFrameLayoutJson);
  }
  if (tableData?.style?.ReadOnly === false || tableData?.style?.ReadOnly === "false") {
    changeControlProperty(tableData.style.ReadOnly, "ReadOnly", tableData?.listviewFrameLayoutJson);
  }
  if (tableData?.style?.ReadOnlyStyle === false || tableData?.style?.ReadOnlyStyle === "false") {
    changeControlProperty(tableData.style.ReadOnlyStyle, "ReadOnlyStyle", tableData?.listviewFrameLayoutJson);
  }
};

export const resetRadios = (id) => {
  const radios = document.querySelectorAll("input[type=radio]" && `input[name=${id}]`);
  radios?.forEach(function (radio) {
    radio.checked = false;
  });
};

export function duplicateValueCheck({ rowIndex, colIndex }, isSuccessful) {
  if (isSuccessful) {
    if (window?.duplicateKey?.length) {
      const index = window.duplicateKey.indexOf(`${rowIndex}_${colIndex}`);
      if (index > -1) {
        window.duplicateKey.splice(index, 1);
      }
    }
  } else {
    if (window?.duplicateKey?.length) {
      const index = window.duplicateKey.indexOf(`${rowIndex}_${colIndex}`);
      if (index === -1) {
        window.duplicateKey.push(`${rowIndex}_${colIndex}`);
      }
    } else {
      window.duplicateKey = [`${rowIndex}_${colIndex}`];
    }
  }

  const callBackJson = {
    isError: !!window?.duplicateKey?.length,
    message: ""
  };
  if (callBackJson.isError) {
    callBackJson.message = "Kindly resolve the errors in the workitem before saving.";
  }

  const state = formStateStore.getState();
  const containerId = state.containerInfo.containerId;

  formStateStore.dispatch(
    updateGridContexts({
      key: containerId,
      name: "globalError",
      value: callBackJson
    })
  );
}

export function makeModifyCall(jsonToSend, data, showAlertConfirmNotifications, setIsError, dataKey = "", controlThemeData1) {
  const contexts = getGlobalContext();
  window.tableCellSaveInProgress = true;

  const remainingURL = "/tableAction/modifyColumn";
  axios.post(remainingURL, jsonToSend, { withCredentials: true }).then((response) => {
    if (response?.data?.status === "0") {
      if (setIsError) {
        setIsError(false);
      }
      if (contexts.setRecordCount) {
        contexts.setRecordCount(jsonToSend.controlId, true);
      }
      if (data?.rowData) {
        let newValue = jsonToSend?.cellData;
        if (jsonToSend?.cellData && dataKey) {
          const [maskingType, CustomMasking, complexFieldType, complexFieldVariablePrecision] = checkMaskingType(
            data,
            dataKey
          );
          if (maskingType || CustomMasking) {
            const finalValue = formatValue(
              maskingType,
              jsonToSend?.cellData,
              CustomMasking,
              complexFieldType,
              complexFieldVariablePrecision
            );
            newValue = finalValue;
          }
        }
        if(data.columnList[jsonToSend.colIndex]?.style?.complexFieldType === "Date" || data.columnList[jsonToSend.colIndex]?.style?.ColumnType === "datetimepick"){
          let dateTimeSeprator =controlThemeData1?.["DateTimeSeperator"] === "1" ? "/" : controlThemeData1?.["DateTimeSeperator"] === "2" ? "-" :controlThemeData1?.["DateTimeSeperator"] === "3" ?"." :"/"
          newValue = newValue?.replaceAll("/", dateTimeSeprator)
        }
        else if(data.columnList[jsonToSend.colIndex]?.style?.complexFieldType === "Short Date" || data.columnList[jsonToSend.colIndex]?.style?.ColumnType === "datepick"){
          let dateSeprator1 =controlThemeData1?.["DateSeperator"] === "1" ? "/" : controlThemeData1?.["DateSeperator"] === "2" ? "-" :controlThemeData1?.["DateSeperator"] === "3" ?"." :"/"
          newValue = newValue?.replaceAll("/", dateSeprator1)
        }
        data.rowData[jsonToSend.rowIndex][jsonToSend.colIndex] = {
          ...data.rowData[jsonToSend.rowIndex][jsonToSend.colIndex],
          value: newValue
        };

        const openCanvasForPreviewAdvance = getOpenCanvasForPreviewAdvance();
        if (openCanvasForPreviewAdvance === "advanceListviewPopupInPreview") {
          updatePartialJSON(data.id, data, false);
        } else {
          updatePartialJSON(data.id, data);
        }
      }
      if (window.onTableCellChange) {
        if(data.columnList[jsonToSend.colIndex]?.style?.complexFieldType === "Date"){
          let dateTimeSeprator =controlThemeData1?.["DateTimeSeperator"] === "1" ? "/" : controlThemeData1?.["DateTimeSeperator"] === "2" ? "-" :controlThemeData1?.["DateTimeSeperator"] === "3" ?"." :"/"
          jsonToSend.cellData = jsonToSend.cellData?.replaceAll("/", dateTimeSeprator)
        }
        else if((data.columnList[jsonToSend.colIndex]?.style?.complexFieldType === "Short Date") || (data.columnList[jsonToSend.colIndex]?.style?.complexFieldType === "shortDate")){
          let dateSeprator1 =controlThemeData1?.["DateSeperator"] === "1" ? "/" : controlThemeData1?.["DateSeperator"] === "2" ? "-" :controlThemeData1?.["DateSeperator"] === "3" ?"." :"/"
          jsonToSend.cellData = jsonToSend.cellData?.replaceAll("/", dateSeprator1)
        }
        window.onTableCellChange(jsonToSend.rowIndex, jsonToSend.colIndex, jsonToSend.cellData, getHooksId(data));
        functions.updateJSON();
      }
      duplicateValueCheck(jsonToSend, true);

      const state = formStateStore.getState();
      const containerId = state.containerInfo.containerId;

      if(data.isAdvanceListview) {
        formStateStore.dispatch(
          updateAdvFormData({
            key: containerId,
            action: "checkAndRemove",
            renderAdvListView: true,
            value: { id: jsonToSend.controlId, colIndex: jsonToSend.colIndex, rowIndex: jsonToSend.rowIndex }
          })
        );
      }
    } else if (response?.data?.status === "-1") {
      const state = formStateStore.getState();
      const containerId = state.containerInfo.containerId;

      if(data.isAdvanceListview) {
        formStateStore.dispatch(
          updateAdvFormData({
            key: containerId,
            action: "add",
            value: { id: jsonToSend.controlId, colIndex: jsonToSend.colIndex, rowIndex: jsonToSend.rowIndex }
          })
        );
      }

      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "DUPLICATE_ROW_MESSAGE"
      });
      setIsError(true);
      duplicateValueCheck(jsonToSend);
    } else if (response?.data?.status === "-2") {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "INVALID_DATA_MESSAGE"
      });
      setIsError(true);
      duplicateValueCheck(jsonToSend);
    }
  })
  .finally(() => {
  window.tableCellSaveInProgress = false;
  });
}

export function onBlur(
  rowIndex,
  columnIndex,
  value,
  controlId,
  containerId,
  tableData,
  timeFlag,
  dateFormat,
  setIsError = () => {},
  showAlertConfirmNotifications,
  dataKey = "",
  controlThemeData
) {
  const jsonToSend = {
    witoken: getWIToken(containerId),
    gdtoken: getGdToken(containerId),
    controlId: controlId,
    rowIndex: rowIndex + "",
    colIndex: columnIndex + "",
    cellData: value !== "Invalid date" ? value : "",
    timeflag: timeFlag,
    dateformat: dateFormat
  };
  makeModifyCall(jsonToSend, tableData, showAlertConfirmNotifications, setIsError, dataKey, controlThemeData);
}

export function validateEmail(value) {
  const emailRegex = new RegExp(/^[A-Za-z0-9][A-Za-z0-9._-]*[A-Za-z0-9]@([A-Za-z0-9-]+\.)+([A-Za-z0-9]{2,4}|museum)$/, "gm");
  const isValidEmail = emailRegex.test(value);
  return isValidEmail;
}

export function getRequiredPhoneMasking(inputMasking) {
  return inputMasking.replaceAll("0", "#");
}

export function dynamicRegexStringGenerator(properties) {
  let regex = "";
  const alphabetsRegex = "\u0621-\u064Aa-zA-Z";
  // const floatRegex = "";
  const numberRegex = "-\\d";
  const onlynumberRegex = "\\d"
  const spacesRegex = "\\s";
  let specialCharRegex = ",.!=@#$%^&*()_+;:[{}'\\/?><`~|\"\\\\\\]\\u20B9-";
  if (properties?.AllowAlphabets === "true") {
    regex += alphabetsRegex;
  }
  if (properties?.AllowNumbers === "true") {
    if(properties?.AllowSpecialChars === "true" && ( properties?.complexFieldType ==="Integer" || properties?.complexFieldType ==="Long" ||  properties?.complexFieldType ==="Float"))
      {
        regex += numberRegex;
      }
      else{
        regex += onlynumberRegex;
      }  
  }
  if (properties?.AllowSpaces === "true") {
    regex += spacesRegex;
  }
  if (properties?.AllowSpecialChars === "true") {
    if (properties?.AllowSpecialCharsContent) {
      specialCharRegex = properties?.AllowSpecialCharsContent?.split("")
        .map((char) => `\\${char}`)
        .join("");
    }
    regex += specialCharRegex;
    } 

  return regex;
}

export function handleInputValidation(value, properties) {
  if (value === "") {
    return true;
  }
  
  let regex = dynamicRegexStringGenerator(properties);
  const finalRegex = new RegExp(`^[${regex}]+$`, "g");
  let valid = finalRegex.test(value);

  return valid;
}

export const handleButtonLinkClick = async (e, MethodName1, controlId, rowId, colIndex) => {
  if (MethodName1 && window[MethodName1]) {
    e.stopPropagation();
    while (window.tableCellSaveInProgress) {
      await new Promise(resolve => setTimeout(resolve, 50));
    }
    window[MethodName1](controlId, rowId, colIndex);
    functions.updateJSON()
  }
};

export function formatDateValue(date, format, controlThemeData) {
  const date1 = new Date(date);
  if (format === "4") {
    let dateSeprator =controlThemeData?.["DateSeperator"] === "1" ? "/" : controlThemeData?.["DateSeperator"] === "2" ? "-" :controlThemeData?.["DateSeperator"] === "3" ?"." :"/"
    const month = date1.toLocaleString("default", { month: "long" });
    return `${date1.getDate()}${dateSeprator}${month.substring(0, 3)}${dateSeprator}${date1.getFullYear()}`;
  } else {
    let dateTimeSeprator =controlThemeData?.["DateTimeSeperator"] === "1" ? "/" : controlThemeData?.["DateTimeSeperator"] === "2" ? "-" :controlThemeData?.["DateTimeSeperator"] === "3" ?"." :"/"
    let month = date1.toLocaleString("default", { month: "long" });
    return `${date1.getDate()}${dateTimeSeprator}${month.substring(
      0,
      3
    )}${dateTimeSeprator}${date1.getFullYear()} ${date1.getHours()}:${date1.getMinutes()}`;
  }
}

export function formatDateValueWithBackSlashSeparator(date, format, controlThemeData) {
  const date1 = new Date(date);
  if (format === "4") {
    const month = date1.toLocaleString("default", { month: "long" });
    return `${date1.getDate()}/${month.substring(0, 3)}/${date1.getFullYear()}`;
  } else {
    let month = date1.toLocaleString("default", { month: "long" });
    return `${date1.getDate()}/${month.substring(
      0,
      3
    )}/${date1.getFullYear()} ${date1.getHours()}:${date1.getMinutes()}:00`;
  }
}

export function reformatToDate(date, format, controlThemeData) {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  if (format === "4") {
    let dateArr = date.split(controlThemeData?.["DateSeperator"] === "1" ? "/" : controlThemeData?.["DateSeperator"] === "2" ? "-" :controlThemeData?.["DateSeperator"] === "3" ?"." :"/");
    let flag42 = 0;
    let q = isNaN(dateArr[0]);
    let r = isNaN(dateArr[2]);
    for (let i of months) {
      if (i === dateArr[1] && !q && 1 <= parseInt(dateArr[0]) <= 12 && !r && dateArr[2].length === 4) {
        flag42 = 1;
      }
    }
    if (flag42 === 1) {
      let formattedDate = `${dateArr[1]}/${dateArr[0]}/${dateArr[2]}`;
      return new Date(formattedDate);
    }
  } else {
    let dateArr = date.split(controlThemeData?.["DateTimeSeperator"] === "1" ? "/" : controlThemeData?.["DateTimeSeperator"] === "2" ? "-" :controlThemeData?.["DateTimeSeperator"] === "3" ?"." :"/");
    dateArr[2] = dateArr[2]?.replace(",", "");
    let dateArrNew = dateArr[2].split(" ");
    let dateArrNew2 = dateArrNew[1].split(":");
    let m = isNaN(dateArrNew2[0]);
    let n = isNaN(dateArrNew2[1]);
    let flag43 = 0;
    let q = isNaN(dateArr[0]);
    let r = isNaN(dateArrNew[0]);
    for (let i of months) {
      if (
        i === dateArr[1] &&
        !q &&
        1 <= parseInt(dateArr[0]) <= 12 &&
        !r &&
        dateArrNew[0].length === 4 &&
        !m &&
        !n &&
        1 <= parseInt(dateArrNew2[0]) <= 24 &&
        1 <= parseInt(dateArrNew2[1]) <= 60
      ) {
        flag43 = 1;
      }
    }

    if (flag43 === 1) {
      let formattedDate = `${dateArr[0]}/${dateArr[1]}/${dateArr[2]}`;
      return new Date(formattedDate);
    }
  }
}

const sanitizeString = (str) => {
  return str
    .replace(/\./g, "_")         // replace all dots with underscores
    .replace(/[*\\/|:<>?"]/g, ""); // remove the listed characters
};

export const handleDownload = async (
  data,
  containerId,
  setAlertData = () => {},
  errorCallback = null,
  cb_data = "Enter"
) => {
  try {
    if (cb_data !== "Enter") {
      return;
    }

    const xmlhttp = new XMLHttpRequest();
    xmlhttp.open(
      "GET",
      `${window.apb_backend_app_context}/tableAction/downloadXls/${getWIToken(containerId)}/${getGdToken(
        containerId
      )}/${data.id}`,
      true
    ); //WdAudit URL changes

    xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xmlhttp.setRequestHeader("Authorization", axios?.defaults?.headers?.common?.["Authorization"]);
    xmlhttp.setRequestHeader("ngsmtoken", ngsmtoken)
    xmlhttp.responseType = "blob";
    xmlhttp.send(JSON.stringify(cb_data));

    xmlhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        let fileName = data.id;
        if(data?.style?.Label) {
          fileName = sanitizeString(data.style.Label);
        }
        if(data?.style?.CustomId) {
          fileName = sanitizeString(data.style.CustomId);
        }

        const blob = this.response;

        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, fileName);
        } else {
          const downloadLink = window?.document?.createElement("a");
          const contentTypeHeader = xmlhttp.getResponseHeader("Content-Type");

          if (contentTypeHeader.includes("application/json") && errorCallback) {
            blob.text().then((res) => {
              let parsedRes = JSON.parse(res);
              if (parsedRes?.status?.maincode === "-1000" || parsedRes?.status?.maincode === "11") {
              }
              errorCallback(JSON.parse(res));
            });
            return false;
          }

          downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }));
          // fileName = decodeURIComponent(fileName);

          downloadLink.download = fileName;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);

          setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "success",
            alertContentKey: "Excel downloaded successfully"
          });

          handleFocus(`${data?.id}_add_record_btn`);
        }
      }
    };
  } catch (err) {
    if (errorCallback) {
      errorCallback(err);
    }
  }
};

export const handleOnInputValidation = (e, limit = 2, extraChecks = true, isNumber = true) => {
  const input = e.target;
  if (!input.value) {
    input.value = isNumber ? 0 : "";
  }
  if (isNumber) {
    input.value = input.value
      .replace(/\D/g, "") // remove non-digits
      .replace(/^0+/, ""); // remove leading zeros
  }
  if (input.value.length > limit && extraChecks) {
    input.value = input.value.slice(0, limit);
  }
}

export const checkIfSubformOpened = (setAlertData=()=>{}, data = {}) => {
  const isListview = data.elem_type === "listview";

  const {
    openCanvasForPreviewAdvance = "",
    currentAdvanceListviewStateJson = {},
    subFormListviewJson = {},
    openCanvasForPreview = ""
  } = getGridStates();

  let shouldAddRecord = true;

  if (openCanvasForPreview === "showDataAdditonSection") {
    shouldAddRecord = false;
    setAlertData({
      open: true,
      showConfirm: "showNotification",
      alertType: "error",
      alertContentKey: `Please close ${
        subFormListviewJson?.style?.Label || subFormListviewJson?.style?.CustomId || subFormListviewJson.id
      } first`
    });
  }

  if (openCanvasForPreviewAdvance === "advanceListviewPopupInPreview") {
    if (currentAdvanceListviewStateJson.style.GridModalType === "modal") {
      shouldAddRecord = true;
    }
    if (
      !isListview &&
      (currentAdvanceListviewStateJson.style.GridModalType === "aboveSection" ||
        currentAdvanceListviewStateJson.style.GridModalType === "belowSection")
    ) {
      shouldAddRecord = false;
    }
    if (
      isListview &&
      (currentAdvanceListviewStateJson.style.GridModalType === "aboveSection" ||
        currentAdvanceListviewStateJson.style.GridModalType === "belowSection")
    ) {
      shouldAddRecord = data.isAdvanceListview;
    }

    if (!shouldAddRecord) {
      setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `Please close ${
          currentAdvanceListviewStateJson?.style?.Label ||
          currentAdvanceListviewStateJson?.style?.CustomId ||
          currentAdvanceListviewStateJson.id
        } first`
      });
    }
  }

  return shouldAddRecord;
};

export const checkIfSubformOpened2 = (setAlertData = () => {}) => {
  const {
    openCanvasForPreviewAdvance = "",
    currentAdvanceListviewStateJson = {},
    subFormListviewJson = {},
    openCanvasForPreview = ""
  } = getGridStates();

  let shouldAddRecord = true;

  if (openCanvasForPreview === "showDataAdditonSection") {
    shouldAddRecord = false;
    setAlertData({
      open: true,
      showConfirm: "showNotification",
      alertType: "error",
      alertContentKey: `Please complete changing records in ${
        subFormListviewJson?.style?.Label || subFormListviewJson?.style?.CustomId || subFormListviewJson.id
      } first`
    });
  }

  if (openCanvasForPreviewAdvance === "advanceListviewPopupInPreview") {
    shouldAddRecord = false;
    setAlertData({
      open: true,
      showConfirm: "showNotification",
      alertType: "error",
      alertContentKey: `Please complete changing records in ${
        currentAdvanceListviewStateJson?.style?.Label ||
        currentAdvanceListviewStateJson?.style?.CustomId ||
        currentAdvanceListviewStateJson.id
      } first`
    });
  }

  return shouldAddRecord;
};

export const checkIfSubformOpened3 = (setAlertData = () => {}, data = {}) => {
  const {
    openCanvasForPreviewAdvance = "",
    currentAdvanceListviewStateJson = {},
    subFormListviewJson = {},
    openCanvasForPreview = ""
  } = getGridStates();

  let shouldAddRecord = true;

  if (
    openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" &&
      openCanvasForPreview === "showDataAdditonSection" &&
      (subFormListviewJson.style["additionmethods"] === "Section above Listview" ||
    subFormListviewJson.style["additionmethods"] === "Section below Listview")
  ) {
    shouldAddRecord = false;
    setAlertData({
      open: true,
      showConfirm: "showNotification",
      alertType: "error",
      alertContentKey: `Please complete changing records in ${
        subFormListviewJson?.style?.Label || subFormListviewJson?.style?.CustomId || subFormListviewJson.id
      } first`
    });
  }

  return shouldAddRecord;
};

export const handleCellFocus = (tableData, colIndex, event, rowId) => {
  if (window.onTableCellFocus) {
    window.onTableCellFocus(getHooksId(tableData), colIndex, event, rowId);
    functions.updateJSON();
  }
}